$(document).ready(function () {
	$(document).on('click', '.hovered-boxes__item', function (event) {
		if ($(event.target).closest('a').length) return;

		const item = $(this);
		const wasOpen = item.hasClass('is-open');
		const list = item.closest('.hovered-boxes__list');

		this.style.setProperty(
			'--hovered-boxes-item-offset',
			this.offsetTop + 'px'
		);

		list.find('.hovered-boxes__item').removeClass('is-open');

		if (!wasOpen) {
			item.addClass('is-open');
			list.addClass('has-open-item');
		} else {
			list.removeClass('has-open-item');
		}
	});

	$(document).on('keydown', '.hovered-boxes__item', function (event) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			$(this).trigger('click');
		}
	});

	$(document).on('mouseleave', '.hovered-boxes__item.is-open', function () {
		if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) {
			return;
		}

		const item = $(this);
		const list = item.closest('.hovered-boxes__list');

		item.removeClass('is-open');
		list.removeClass('has-open-item');
	});
});



// WEBPACK FOOTER //
// ./resources/js/modules/hovered-boxes.js